import { Injectable } from '@angular/core';
import { FriendlyCaptchaSDK, WidgetHandle } from '@friendlycaptcha/sdk';
import { environment } from '@perval/shared';

/**
 * Encapsule le SDK Friendly Captcha pour rendre son instanciation testable
 * et isoler la dépendance externe du composant d'inscription.
 */
@Injectable({
  providedIn: 'root',
})
export class FriendlyCaptchaService {
  private sdk: FriendlyCaptchaSDK | null = null;

  /**
   * Crée un widget Friendly Captcha dans l'élément fourni.
   * La site-key est publique (front), la clé secrète reste côté back.
   */
  createWidget(element: HTMLElement): WidgetHandle {
    if (!this.sdk) {
      this.sdk = new FriendlyCaptchaSDK();
    }

    return this.sdk.createWidget({
      element,
      sitekey: environment.friendlyCaptchaSiteKey,
      startMode: 'none',
    });
  }
}
